import { Dispatch, SetStateAction, useState } from "react"
import { jobFilter } from "utils"
import { getUpdatedStateForKey } from "./FiltersUtils/getUpdatedStateForKey"
import setNewFilterList from "./FiltersUtils/setNewFilterList"
import NewFilters from "./NewFilters"
import { ProductFilters, StateType, initialState as cleanState } from "./ProductsLobby"

const countFilters = (state: StateType) => {
  let visibleCount = 0
  let totalCount = 0

  Object.keys(state).forEach((key) => {
    // Assuming you want to include every filter for counting
    if (key !== "designations" && key !== "subsidiaries") {
      const items = state[key as keyof StateType]
      const realItems = items.filter((item) => item.number !== 0)
      totalCount += realItems.length // Add to total count of filters

      const visibleItems = items.filter((item) => item.visibility && item.number !== 0)
      visibleCount += visibleItems.length // Add to count of visible filters
    }
  })

  return { visibleCount, totalCount }
}

const allowedFilters = {
  // ashkalit: ["categories", "subCategories", "productKeyFeatures"],
  ashkalit: ["categories"],
  "bg-bond": ["categories"],
  ashbond: ["categories"],
  nitzavim: ["categories"],
  itumit: ["categories"],
  israbeton: ["categories"],
  quarries: ["categories"],
}

type Props = {
  state: StateType
  setState: Dispatch<SetStateAction<StateType>>
  filters: ProductFilters
  homepage?: boolean
  element?: string
  locale?: string
  homepageUrl?: string
  setIsFilterApplied?: any
  page: string
  products: any
  messages: {
    showAll: string
    all: string
    showResults: string
    noProductsFound: string
    toProduct: string
    filters: string
    moreCategory: string
    allProducts: string
    categories: string
    subCategories: string
    productKeyFeatures: string
  }
  interimState: StateType
  setInterimState: Dispatch<SetStateAction<StateType>>
}
function Filters({
  setState,
  state,
  filters,
  setIsFilterApplied = () => null,
  page,
  products,
  messages,
  interimState,
  setInterimState,
}: Props) {
  const [initialState] = useState(state)

  const handleSelectChange = (
    key: keyof StateType,
    optionId: number,
    newVisibility: boolean,
    category?: boolean,
    cleanSlate?: boolean,
  ) => {
    let updatedState = getUpdatedStateForKey(interimState, key, optionId, newVisibility)
    if (cleanSlate) {
      setInterimState(initialState)
      setState(initialState)
      setIsFilterApplied(false)
    } else {
      updatedState = setNewFilterList(initialState, updatedState, key, products)
      setInterimState(updatedState)
    }

    if (category) {
      const realCategories = updatedState[key].filter((opt) => opt.number !== 0)
      const allSelected = realCategories.every((opt) => opt.visibility)
      if (allSelected) {
        setInterimState(initialState)
        setState(initialState)
        setIsFilterApplied(false)
      } else {
        setState(updatedState)
        setIsFilterApplied(true)
      }
    }
  }
  const handleOtherFilters = () => {
    setState(interimState)
    setIsFilterApplied(true)
  }

  const handleClearInnerFilters = () => {
    setInterimState(cleanState(filters))
    setState(cleanState(filters))
    setIsFilterApplied(false)
    jobFilter("איפוס", "איפוס", "Filter - products")
  }
  const { totalCount, visibleCount } = countFilters(state)

  return (
    <>
      {(allowedFilters as any)[page] ? (
        <>
          <NewFilters
            onChange={(optionId, newVisibility, category, cleanSlate) => {
              handleSelectChange("categories", optionId, newVisibility, category, cleanSlate)
            }}
            otherOnChange={(filterKey, optionId, newVisibility) => {
              handleSelectChange(filterKey, optionId, newVisibility)
            }}
            handleOtherFilters={handleOtherFilters}
            interimState={interimState}
            allowedFilters={allowedFilters}
            page={page}
            totalCount={totalCount}
            count={visibleCount}
            filters={filters}
            label={filters.categories.label}
            messages={messages}
            handleClearFilters={handleClearInnerFilters}
            handleClearInnerFilters={handleClearInnerFilters}
            countFilters={countFilters}
          />
        </>
      ) : (
        <></>
      )}
    </>
  )
}

export default Filters
